/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { candidacyCvDestroy } from '../../axios/candidacyCvDestroy'
import type {
	CandidacyCvDestroyError,
	CandidacyCvDestroyPathParams,
	CandidacyCvDestroyResponse,
} from '../../types/CandidacyCvDestroy'

export const candidacyCvDestroyMutationKey = () =>
	[{ url: '/candidate-center/organisations/:organisation/candidacies/:candidacy/cv/:cv' }] as const

export type CandidacyCvDestroyMutationKey = ReturnType<typeof candidacyCvDestroyMutationKey>

export type CandidacyCvDestroyVariables = {
	organisation: CandidacyCvDestroyPathParams['organisation']
	candidacy: CandidacyCvDestroyPathParams['candidacy']
	cv: CandidacyCvDestroyPathParams['cv']
}

/** @see backend/nexus/modules/CandidateCenter/Http/Controllers/CandidacyCvController.php CandidacyCvController::destroy */
export function useCandidacyCvDestroy<TContext = unknown>(
	options?: UseMutationOptions<
		CandidacyCvDestroyResponse,
		AxiosError<CandidacyCvDestroyError>,
		CandidacyCvDestroyVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: candidacyCvDestroyMutationKey(),
		mutationFn: ({ organisation, candidacy, cv }: CandidacyCvDestroyVariables) =>
			candidacyCvDestroy(organisation, candidacy, cv, config).then(res => res.data),
		...options,
	})
}
